const cfg = {
    '83': '天猫',
    '123': '淘宝',
    '3': '京东'
}

export default cfg